import { defineMessages } from 'react-intl';

export const messages: {
	optionDropdownNewOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	optionDropdownNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	optionDropdownSelect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	otherOption: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	otherOptionTextLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	searchResultsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	optionDropdownNewOption: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.option-dropdown-new-option',
		defaultMessage: 'New option...',
		description: 'Placeholder text in dropdown when a new option can be created.',
	},
	optionDropdownNoOptions: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.option-dropdown-no-options',
		defaultMessage: 'No options',
		description: 'Placeholder text in dropdown when there are no options.',
	},
	optionDropdownSelect: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.option-dropdown-select',
		defaultMessage: 'Select...',
		description: 'Placeholder text in dropdown waiting for the user to select something.',
	},
	otherOption: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.other-option',
		description: 'The label for the Other option in choice fields',
		defaultMessage: 'Other...',
	},
	otherOptionTextLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.other-option-text-label',
		description:
			'Label for the multiple select field other text box in edit mode, for accessibility',
		defaultMessage: '{label} multiple select field other option text area',
	},
	searchResultsLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.search-results-label',
		defaultMessage:
			'{numberOfSearchResults, plural, one {# search result} other {# search results}}',
		description: 'Label above options describing how many search results were found',
	},
});
